import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-scroll";
import logo from "./images/undura_logo.svg";
import logoTablet from "./images/tablet_logo.png";
import triangle from "./images/lang_triangle.svg";
import mob_triangle from "./images/mobile_lang_tr.svg";
import { motion } from "framer-motion";
import DevelopmentButton from "./DevelopmentButton";

const Header = ({mode = "lite"}) => {
    const [popupActive, setPopupActive] = useState(false);
    const isTablet = window.innerWidth > 768 && window.innerWidth < 1440;
    const popupClasses = `popup_development ${popupActive ? "activated" : ""}`;
    //const popupClasses = `popup_development`;
    const [mobMenuOpened, setMobMenuOpened] = useState(false)
    const menuRef = useRef(null);
    const burgerRef = useRef(null);
    const [hoverMode, setHoverMode] = useState(null);
    const currentPath = window.location.pathname;
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobMenuOpened && menuRef.current && !menuRef.current.contains(event.target) && burgerRef.current && !burgerRef.current.contains(event.target)) {
                setMobMenuOpened(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [mobMenuOpened]);
    const menus = {
        lite: [
            {label: "For Donors", href: "/for-donors"},
            {label: "For Organizations", href: "/for-organizations"},
            {label: "Platforms", href: "/platforms"}, {label: "Demo", href: "#", dev:true},],
        core: [{label: "For Issuers", href: "/for-issuers"}, {
            label: "For Investors",
            href: "/for-investors"
        }, {label: "Architecture", href: "/architecture"}, {label: "Resources", href: "/resources", dev: true},],
        presentation: [{label: "Problem", to: "problem", offset: 200}, {
            label: "Solution",
            to: "solution",
            offset: -80
        }, {label: "Two tracks", to: "tracks", offset: 80}, {label: "Contact", to: "contact", offset: -80},],
    };


    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };



    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }
    const [popupActiveButton, setPopupActiveButton] = useState(false);
    const [popupActiveButton1, setPopupActiveButton1] = useState(false);
    const [langVisible, setLangVisible] = useState(false)
    const popupClassesButton = `popup_development_button ${popupActiveButton ? "activated" : ""}`;
    const popupClassesButton1 = `popup_development_button ${popupActiveButton1 ? "activated" : ""}`;

    const renderMenuItems = () => {
        if (mode === "presentation") {
            return menus.presentation.map((item, i) => (
                <div className="header_menu_item" key={i}><Link to={item.to} smooth={true} duration={500}
                                                                offset={item.offset} spy={true}
                                                                activeClass="active"> {item.label} </Link></div>));
        }
        return menus[mode].map((item, i) =>
        {
            const isActive = currentPath === item.href;
            return (
            <div className={`header_menu_item ${isActive ? "active_link" : ""}`} key={i}>
                {item.dev ?
                    <a className = "pos_center_popup" style = {{position: "relative"}} onMouseOver={() => setPopupActiveButton1(true)}
                       onMouseLeave={() => setPopupActiveButton1(false)}>{item.label}
                        <div className={popupClassesButton1} > Redirect temporarily <span>disabled</span> — module <span>under development</span>.</div>
                </a> : <a href={item.href}>{item.label}</a>}
            </div>)});
    };
    return (<div className="undura_header">
        <div className="header_content"><a
            href={mode === "core" ? "/core" : mode === "presentation" ? "/presentation" : "/"}
            className="undura_logo"> {mode === "presentation" ? <img src={logo} alt="Undura Logo"/> :
            <img src={isTablet ? logoTablet : logo} alt="Undura Logo"/>} </a>
            <div className="center_header_menu"> {(mode === "lite" || mode === "core") && (
                <div className="lite_core_handler">
                    <div
                        className={`top_handler ${
                            (hoverMode === "core" || (!hoverMode && mode === "core")) ? "core_active" : ""
                        }`}
                    ></div>
                    <div
                        className={`lite ${mode === "lite" ? "active" : ""}`}
                        onMouseEnter={() => setHoverMode("lite")}
                        onMouseLeave={() => setHoverMode(null)}
                    >
                        {mode === "core" ? <a href="/">Lite</a> : "Lite"}
                    </div>

                    <div
                        className={`core ${mode === "core" ? "active" : ""}`}
                        onMouseEnter={() => setHoverMode("core")}
                        onMouseLeave={() => setHoverMode(null)}
                    >
                        {mode === "lite" ? <a href="/core">Core</a> : "Core"}
                    </div>
                </div>)} {renderMenuItems()} </div>
            <div className="lang_login_block"> {mode === "presentation" ? (
                <a href = "https://undura.com/"><div className="open_hub_button">Visit website</div></a>) : (<>
                <div className="language_block" onMouseOver={() => setLangVisible(true)} onMouseLeave={() => setLangVisible(false)}>

                    Eng

                    <div className = {`lang_list ${langVisible ? "visible" : ""}`}>
                         Eng
                    </div>
                    <img src={triangle} alt=""/></div>
                <div className="login_block" style={{position:"relative"}} onMouseOver={() => setPopupActiveButton(true)}
                     onMouseLeave={() => setPopupActiveButton(false)}>Log in
                </div>
                <div className="open_hub_button" style={{position:"relative"}} onMouseOver={() => setPopupActiveButton(true)}
                     onMouseLeave={() => setPopupActiveButton(false)}>Open HUB
                    <div className={popupClassesButton} > Redirect temporarily <span>disabled</span> — module <span>under development</span>.</div>
                </div>
            </>)} </div>
            <div className={`mobile_burger ${mobMenuOpened ? "open_menu" : ''}`} onClick={() => {
                setMobMenuOpened(!mobMenuOpened)
            }} ref={burgerRef}>
                <div className="mobile_burger_lines">
                    <div></div>
                    <div className="central_line"></div>
                    <div></div>
                </div>
            </div>
        </div>
        {mode === "presentation" && (
            <div className={popupClasses}> Redirect temporarily <span>disabled</span> — module <span>under development</span>. </div>)}
            <div className={`mobile_manu_block ${mobMenuOpened ? "open_menu" : ''}`} ref={menuRef}>
                {mode === "presentation"
                    ? menus.presentation.map((item, i) => (
                        <div className="header_mobile_menu_item" key={i}>
                            <Link
                                to={item.to}
                                smooth={true}
                                duration={500}
                                offset={item.offset}
                                spy={true}
                                onClick={() => setMobMenuOpened(false)}
                                activeClass="active_link"
                            >
                                {item.label}
                            </Link>
                        </div>
                    ))
                    : menus[mode].map((el, i) => {
                        const isActive = currentPath === el.href;

                        return el.dev ?
                           ""
                        :  (<div className={`header_mobile_menu_item ${isActive ? "active_link" : ""}`} key={i}>
                            <a href={el.href}>{el.label}</a>
                        </div>)
                    })}
                <div className="language_handler_modile" onMouseOver={() => setLangVisible(true)} onMouseLeave={() => setLangVisible(false)}>
                    Eng <img src={mob_triangle} alt=""/>
                    <div className = {`lang_list ${langVisible ? "visible" : ""}`}>
                        Eng
                    </div>
                </div>
                {/*<div className="mob_menu_buttons">
                    <div className="open_hub_mobile_button">Open HUB</div>
                    <div className="log_in_mobile_button">Log in</div>
                </div>*/}
            </div>
    </div>

    );
};
export default Header;